module.exports = __webpack_public_path__ + "media/newstyle/images/info-pink-9535ee17b0f1d7607df9c598b3a71948.svg";